export enum View {
  Daily = "daily",
  Day = "day",
  Week = "week",
  Period = "period",
  FcMonth = "fcMonth",
  FcWeek = "fcWeek",
  Month = "month",
}
